import { render } from "./blog-carousel.vue?vue&type=template&id=d3b11b34"
import script from "./blog-carousel.vue?vue&type=script&lang=js"
export * from "./blog-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__